<div class="manual-shell">
  <div class="manual-container">
    <header class="page-header">
      <div class="page-header-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <path d="M9.1 9a3 3 0 1 1 5.7 1.3c-.7 1.1-1.8 1.5-2.5 2.4-.3.4-.3.8-.3 1.3"/>
          <line x1="12" y1="17" x2="12.01" y2="17"/>
        </svg>
      </div>
      <div>
        <h1>Manual GPL</h1>
        <p>Indice de telas e orientacoes de uso do sistema</p>
      </div>
    </header>

    <div class="manual-layout">
      <aside class="manual-index">
        <div class="index-title">Indice</div>

        <div class="index-search">
          <input type="text" [(ngModel)]="filtroIndice" placeholder="Buscar no indice">
        </div>

        <section class="index-group" *ngFor="let tela of telasFiltradas()">
          <h2>{{ tela.titulo }}</h2>
          <p>{{ tela.descricao }}</p>

          <button type="button"
                  class="index-item"
                  *ngFor="let subtela of tela.subtelas"
                  [class.active]="subtelaAtiva(subtela)"
                  [disabled]="!subtela.manual"
                  (click)="selecionarSubtela(subtela)">
            <span class="index-dot"></span>
            <span>
              <strong>{{ subtela.titulo }}</strong>
              <small>{{ subtela.descricao }}</small>
            </span>
          </button>
        </section>
      </aside>

      <main class="manual-content">
        <section class="manual-card hero-card">
          <div>
            <span class="manual-eyebrow">Tela documentada</span>
            <h2>{{ tituloTelaAtual() }}</h2>
            <p>{{ descricaoTelaAtual() }}</p>
          </div>

          <div class="hero-mini" aria-hidden="true">
            <div class="mini-toolbar">
              <span>Cliente</span>
              <span>Datas</span>
              <span>Buscar</span>
            </div>
            <div class="mini-report">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </section>

        <section class="manual-card" *ngIf="manualSelecionado === 'demonstrativo'">
          <div class="section-heading">
            <h3>Fluxo principal</h3>
            <p>Leitura da tela da esquerda para a direita.</p>
          </div>

          <div class="click-steps">
            <div class="click-card">
              <div class="fake-screen">
                <span class="fake-radio active"></span>
                <span class="fake-input long"></span>
                <span class="fake-button">Buscar</span>
              </div>
              <strong>1. Selecione e consulte</strong>
              <p>Escolha Cliente ou Vendedor, informe o periodo e clique em Buscar.</p>
            </div>

            <div class="click-card">
              <div class="fake-screen">
                <span class="fake-button green">WhatsApp</span>
                <span class="fake-button blue">PDF</span>
                <span class="fake-button green">Imprimir</span>
              </div>
              <strong>2. Gere saidas</strong>
              <p>Use WhatsApp, PDF ou Impressao conforme a necessidade do atendimento.</p>
            </div>

            <div class="click-card">
              <div class="fake-screen fake-menu">
                <span class="fake-button dark">Acoes</span>
                <span class="fake-dropdown">Alterar forma de pagamento</span>
                <span class="fake-dropdown">Finalizar vendas</span>
              </div>
              <strong>3. Aplique acoes</strong>
              <p>Marque vendas na tabela e use o menu para processar alteracoes em lote.</p>
            </div>
          </div>
        </section>

        <section class="manual-card" *ngIf="manualSelecionado === 'impressao'">
          <div class="section-heading">
            <h3>Fluxo principal</h3>
            <p>Da busca do cliente ate a impressao ou PDF do orcamento.</p>
          </div>

          <div class="click-steps">
            <div class="click-card">
              <div class="fake-screen">
                <span class="fake-input long"></span>
                <span class="fake-button">Buscar</span>
              </div>
              <strong>1. Busque o cliente</strong>
              <p>Informe cliente, periodo e carregue as vendas disponiveis para impressao.</p>
            </div>

            <div class="click-card">
              <div class="fake-screen fake-list">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <strong>2. Selecione a venda</strong>
              <p>Clique na linha da venda desejada para abrir o orcamento em A4.</p>
            </div>

            <div class="click-card">
              <div class="fake-screen">
                <span class="fake-button dark">Voltar</span>
                <span class="fake-button blue">PDF</span>
                <span class="fake-button green">Imprimir</span>
              </div>
              <strong>3. Gere a saida</strong>
              <p>Confira os dados, ajuste zoom se precisar e imprima ou gere o PDF.</p>
            </div>
          </div>
        </section>

        <section class="manual-card" *ngIf="manualSelecionado === 'comissoes'">
          <div class="section-heading">
            <h3>Fluxo principal</h3>
            <p>Da consulta do periodo ate a conferencia dos valores de comissao.</p>
          </div>

          <div class="click-steps">
            <div class="click-card">
              <div class="fake-screen">
                <span class="fake-input"></span>
                <span class="fake-input"></span>
                <span class="fake-button">Buscar</span>
              </div>
              <strong>1. Defina o periodo</strong>
              <p>Informe data inicial, data final e execute a busca do relatorio.</p>
            </div>

            <div class="click-card">
              <div class="fake-screen fake-menu">
                <span class="fake-dropdown">Vendedor</span>
                <span class="fake-dropdown">Empresa</span>
                <span class="fake-dropdown">Status</span>
              </div>
              <strong>2. Refine os filtros</strong>
              <p>Aplique filtros para conferir somente os dados necessarios.</p>
            </div>

            <div class="click-card">
              <div class="fake-screen fake-list">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <strong>3. Confira detalhes</strong>
              <p>Analise totais, agrupamentos e linhas analiticas antes de exportar.</p>
            </div>
          </div>
        </section>

        <section class="manual-card">
          <div class="section-heading">
            <h3>Funcoes da tela</h3>
            <p>Resumo das principais funcoes na ordem visual da tela.</p>
            <button type="button"
                    class="guided-tour-btn"
                    *ngIf="manualSelecionado === 'demonstrativo'"
                    (click)="iniciarTourDemonstrativo()">
              Iniciar tour guiado
            </button>
          </div>

          <div class="function-grid">
            <article class="function-item" *ngFor="let funcao of funcoesTelaAtual()">
              <h4>{{ funcao.titulo }}</h4>
              <p>{{ funcao.descricao }}</p>
              <button type="button" class="how-link" (click)="abrirComoUsar(funcao)">
                Como usar
              </button>
            </article>
          </div>
        </section>

        <section class="manual-card" *ngIf="manualSelecionado === 'demonstrativo'">
          <div class="section-heading">
            <h3>Acoes em lote</h3>
            <p>Use os checkboxes da tabela antes de executar alteracoes.</p>
          </div>

          <div class="action-map">
            <div class="action-box">
              <span class="checkmark"></span>
              <strong>Selecionar vendas</strong>
              <p>Marque uma ou mais vendas na tabela do demonstrativo.</p>
            </div>
            <div class="action-arrow"></div>
            <div class="action-box">
              <span class="menu-mark"></span>
              <strong>Abrir menu</strong>
              <p>Escolha finalizar, alterar cliente, forma de pagamento, prefixo ou cotacao.</p>
            </div>
            <div class="action-arrow"></div>
            <div class="action-box">
              <span class="save-mark"></span>
              <strong>Confirmar</strong>
              <p>Revise a lista no modal e confirme apenas quando estiver correto.</p>
            </div>
          </div>
        </section>

        <section class="manual-card" *ngIf="manualSelecionado === 'impressao'">
          <div class="section-heading">
            <h3>Estrutura do orcamento</h3>
            <p>Blocos principais da pagina impressa.</p>
          </div>

          <div class="action-map">
            <div class="action-box">
              <span class="menu-mark"></span>
              <strong>Cabecalho e cliente</strong>
              <p>Logo, numero do orcamento, dados de faturamento e entrega.</p>
            </div>
            <div class="action-arrow"></div>
            <div class="action-box">
              <span class="checkmark"></span>
              <strong>Itens da venda</strong>
              <p>Produtos, seriais, IPI, valores e totais com zebra visual.</p>
            </div>
            <div class="action-arrow"></div>
            <div class="action-box">
              <span class="save-mark"></span>
              <strong>Pagamento</strong>
              <p>QR-Codes e dados bancarios mantidos juntos no rodape.</p>
            </div>
          </div>
        </section>
      </main>
    </div>
  </div>

  <div class="manual-modal-backdrop" *ngIf="modalComoUsar" (click)="fecharComoUsar()">
    <section class="manual-modal" (click)="$event.stopPropagation()">
      <header class="manual-modal-header">
        <div>
          <span>Como usar</span>
          <h2>{{ modalComoUsar.titulo }}</h2>
        </div>
        <button type="button" class="manual-modal-close" (click)="fecharComoUsar()">x</button>
      </header>

      <div class="manual-modal-body">
        <div class="manual-shot" [ngClass]="'manual-shot-' + modalComoUsar.tipoImagem">
          <div class="shot-topline"></div>
          <div class="shot-filter-row">
            <span class="shot-radio"></span>
            <span class="shot-radio second"></span>
            <span class="shot-input"></span>
            <span class="shot-date"></span>
            <span class="shot-date"></span>
            <span class="shot-button"></span>
          </div>
          <div class="shot-action-row">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="shot-table">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="shot-pointer"></div>
        </div>

        <div class="manual-instructions">
          <p class="manual-modal-intro">
            Siga estes passos para usar esta funcao em {{ tituloTelaAtual() }}.
          </p>

          <ol>
            <li *ngFor="let passo of modalComoUsar.comoUsar">{{ passo }}</li>
          </ol>
        </div>
      </div>
    </section>
  </div>

  <div class="guided-tour-overlay"
       *ngIf="funcaoTourDemonstrativo() as funcao"
       [ngClass]="classeTourDemonstrativo()">
    <div class="guided-tour-screen" aria-hidden="true">
      <img src="assets/manual/demonstrativo-vendas-tour.png" alt="">
      <div class="guided-tour-spotlight"></div>
    </div>

    <aside class="guided-tour-card">
      <div class="guided-tour-card-top">
        <span>Tour guiado</span>
        <strong>{{ progressoTourDemonstrativo() }}</strong>
      </div>
      <h2>{{ funcao.titulo }}</h2>
      <p>{{ funcao.descricao }}</p>

      <div class="guided-tour-actions-card">
        <button type="button"
                class="guided-tour-secondary"
                (click)="anteriorTourDemonstrativo()"
                [disabled]="tourDemonstrativoIndice === 0">
          Voltar
        </button>
        <button type="button"
                class="guided-tour-secondary"
                (click)="fecharTourDemonstrativo()">
          Fechar
        </button>
        <button type="button"
                class="guided-tour-primary"
                (click)="proximoTourDemonstrativo()">
          {{ tourDemonstrativoIndice === funcoesDemonstrativo.length - 1 ? 'Concluir' : 'Proximo' }}
        </button>
      </div>
    </aside>
  </div>
</div>
